<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles.js'
	import { get_mail_greetings, save_mail_salutation } from '../library/scripts/utils.js'
	import {
		storeActiveBlock,
		storeShowFinishedBlocks,
		storeShowMail,
		storeShowCreateButtons,
	} from '../library/scripts/Store.svelte'

	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../modals/Alert.svelte'

	export let blockName = null

	storeShowMail.set(true)
	storeShowCreateButtons.set(false)
	//mail answers
	let mailGreeting = 'test'
	let mailSignature = 'signature'

	const mailInfo = get_mail_greetings()
	mailInfo.then((value) => {
		mailGreeting = value.greeting
		mailSignature = value.signature
	})

	//active block
	const stoActiveBl = storeActiveBlock.subscribe((value) => {
		blockName = value
	})

	const globals = getContext('globals')
	const colorMain = globals.adminColorMain

	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const fsL = globals.fsL
	const inputBg = globals.adminInputBg
	const inputBgFocus = globals.adminInputBgFocus
	const buttonBgHover = globals.adminButtonBgHover

	let showError = false

	//error message
	let message = ''
	let showOkButton = false

	const save_mail_greeting = async () => {
		if (!mailSignature) {
			showError = true
			message = 'please add signature'
		}

		if (!mailGreeting) {
			showError = true
			message = 'please add greeting'
		}

		if (showError) return

		const salutation = await save_mail_salutation(mailGreeting, mailSignature)
		if (salutation) {
			storeShowMail.set(false)
			storeShowFinishedBlocks.set(true)
			storeShowCreateButtons.set(true)
			storeActiveBlock.set(null)
		}
	}

	//close main window
	const close_window = () => {
		storeShowMail.set(false)
		storeShowFinishedBlocks.set(true)
		storeShowCreateButtons.set(true)
		storeActiveBlock.set(null)
	}

	const close_alert = () => {
		showError = false
	}

	onDestroy(() => {
		stoActiveBl
	})
</script>

{#if $storeShowMail}
	{#await mailInfo then mI}
		<main id="updatemenu" use:styles={{ colorMain, fsN }} transition:slide={{ duration: 500 }}>
			<div class="block_title" use:styles={{ fsL, colorMain }}>{blockName}</div>

			<div class="sub_title" use:styles={{ fsS, colorMain }}>Mail Greeting</div>
			<input type="text" use:styles={{ inputBg, inputBgFocus, colorMain, fsS }} bind:value={mailGreeting} data-input />
			<div class="sub_title" use:styles={{ fsS, colorMain }}>Mail Signature</div>
			<input type="text" use:styles={{ inputBg, inputBgFocus, colorMain, fsS }} bind:value={mailSignature} data-input />

			<div class="button_container">
				<button on:click={close_window} use:styles={{ colorMain, fsXS, buttonBgHover }}>close</button>
				<button on:click={save_mail_greeting} use:styles={{ colorMain, fsXS, buttonBgHover }}>save</button>
			</div>
		</main>
	{/await}
{/if}
{#if showError}
	<Shader>
		<div slot="content">
			<Alert {message} {showOkButton} on:alertclose={close_alert} />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: 95vw;
		display: flex;
		flex-direction: column;
		padding: 2%;
		color: var(--colorMain);
		font-size: var(--fsN);
		user-select: none;
	}

	input[type='text'] {
		background-color: var(--inputBg);
		color: var(--colorMain);
		width: 90%;
		font-size: var(--fsS);
		border: 1px solid green;
	}

	input[data-input] {
		margin-left: 20px;
		width: 60%;
	}

	button {
		background-color: transparent;
		color: var(--colorMain);
		border: 1px solid var(--colorMain);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-left: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	.block_title {
		color: var(--colorMain);
		font-size: var(--fsL);
		text-transform: uppercase;
		font-weight: bold;
		margin: 20px 0px 20px 0px;
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border-top: 1px solid green;
		margin-top: 20px;
		padding-top: 25px;
	}

	.sub_title {
		color: var(--colorMain);
		font-size: var(--fsS);
		margin-top: 20px;
		margin-bottom: 15px;
	}
</style>
